/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Config } from '@leverege/plugin';
import { Button, Flex, Label, Pane, Text, TextArea } from '@leverege/ui-elements';
import MultiSelector from '../components/MultiSelector';
import S from './PendingSaleMessage.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PendingSaleMessage({
  state: pState,
  vehicles,
  onAdd,
  onRemove
}) {
  const [state, setState] = pState;
  useEffect(() => {
    setState(s => ({
      ...s,
      pendingSaleMessage: getDefaultMessage(vehicles)
    }));
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodySmall",
      children: "Send an SMS to any person with details about this sale. Message and data rates may apply."
    }), /*#__PURE__*/_jsx(Pane, {
      className: S.divider
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "colXL",
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: "Select Recipients"
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: "Click the Add button below to select from a list of all registered users at this location, or to manually add users by phone number. You may select up to 5 recipients."
          })]
        }), /*#__PURE__*/_jsx(MultiSelector, {
          values: state?.pendingSaleMessageRecipients,
          valueKey: "id",
          onAdd: onAdd,
          onRemove: onRemove,
          limit: 5
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: "Edit Message"
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: "Messages over 160 characters will be sent as multiple texts."
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colL",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "colS",
            children: [/*#__PURE__*/_jsx(TextArea, {
              className: S.textArea,
              value: state?.pendingSaleMessage,
              onChange: ({
                value
              }) => setState(s => ({
                ...s,
                pendingSaleMessage: value.slice(0, 480)
              }))
            }), /*#__PURE__*/_jsx(Label, {
              variant: "inputCaption",
              className: state?.pendingSaleMessage?.length === 480 ? S.inputCaptionDanger : S.inputCaption,
              children: `${state?.pendingSaleMessage?.length} ${state?.pendingSaleMessage?.length === 1 ? 'character' : 'characters'}`
            })]
          }), /*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            className: S.resetEdits,
            disabled: state?.pendingSaleMessage === getDefaultMessage(vehicles),
            onClick: () => setState(s => ({
              ...s,
              pendingSaleMessage: getDefaultMessage(vehicles)
            })),
            children: "Reset Edits"
          })]
        })]
      })]
    })]
  });
}
function getDefaultMessage(vehicles) {
  const vehicle = vehicles[0].data;
  const lines = [Config.get('PendingSaleMessage', 'label', 'Sale Pending. Unpair Locator'), `Stock Number: ${vehicle?.data?.stocknumber}`, `VIN: ${vehicle?.data?.vin}`, [vehicle?.data?.colorName, vehicle?.data?.year, vehicle?.data?.make, vehicle?.data?.model].filter(v => !!v).join(' ')];
  return lines.join('\n');
}
export default PendingSaleMessage;